import { useMutation, useQuery, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { brandedAppsBuilderUI } from "@/react/helpers/urlHelpers/internalApi/brandedAppsBuilderUI";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { useToast } from "@circle-react-shared/uikit/ToastV2";

interface WelcomeSpaceFormProps {
  new_member_space_id: string;
  regular_member_space_id: string;
}

// TODO: Remove after feature flag welcome_page_home_tabs_enabled is removed
export const useWelcomeSpacesApi = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery<
    { welcome_spaces: WelcomeSpaceFormProps },
    ApiError
  >({
    queryKey: ["welcome-spaces"],
    queryFn: () => reactQueryGet(brandedAppsBuilderUI.welcomeSpaces.get()),
  });

  const { mutateAsync: updateWelcomeSpaces } = useMutation({
    mutationFn: (payload: WelcomeSpaceFormProps) =>
      reactQueryPut(brandedAppsBuilderUI.welcomeSpaces.put(), payload),
    onSuccess: response => {
      queryClient.setQueryData(["welcome-spaces"], response);
      toast.success(
        t("settings_nav_v3.branded_apps_dashboard.welcome_space.save.success"),
      );
    },
    onError: () => {
      toast.error(
        t("settings_nav_v3.branded_apps_dashboard.welcome_space.save.error"),
      );
    },
  });

  return { data, isLoading, error, updateWelcomeSpaces };
};
